/**
 * A phone held sideways: wide enough for the tablet layout but too short for its chrome. The app bar, page padding,
 * page titles and toolbars shrink so the list keeps most of the screen. Matches the rule in globals.css.
 */
export const SHORT_LANDSCAPE = '@media (orientation: landscape) and (max-height: 500px)';
